<template>
  <g>
    <path
      v-bind="$attrs"
      :d="`M ${startCoord.x} ${startCoord.y} A ${arcRadius} ${arcRadius} 0 ${largeArcFlag ? '1' : '0'} 1 ${endCoord.x} ${endCoord.y}`"
      :stroke-width="strokeWidth"
      :style="[colorData.colorStyles]"
      :class="[
        colorData.colorClasses,
        { 'repartition-doughnut-quarter-arc__disabled': disabled }
      ]"
      class="repartition-doughnut-quarter-arc"
      @mouseover="$vuetify.breakpoint.mobile ? null : tooltipVisible = true"
      @mouseleave="$vuetify.breakpoint.mobile ? null : tooltipVisible = false"
      @click="$vuetify.breakpoint.mobile ? tooltipVisible = true : null"
    />

    <circle
      :id="`tooltip-activator-${id}`"
      r="0"
      :cx="activatorCoord.x"
      :cy="activatorCoord.y"
    />

    <foreignObject>
      <DoughnutResume
        v-if="tooltip"
        v-model="tooltipVisible"
        :activator="`#tooltip-activator-${id}`"
        :item="item"
        :percentage="activatorPercentage"
        :radius="radius"
      />
    </foreignObject>
  </g>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import DoughnutResume from './doughnut-resume.vue'
import { getTextColorData } from './colorUtils'

export default {
  name: 'RepartitionDoughnutQuarterArc',

  components: {
    DoughnutResume
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    startValue: {
      type: Number,
      required: true
    },
    quartersGap: {
      type: Number,
      default: 0
    },
    radius: {
      type: Number,
      required: true
    },
    strokeWidth: {
      type: Number,
      required: true
    },
    tooltip: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      id: uuidv4(),

      tooltipVisible: false
    }
  },

  computed: {
    arcRadius () {
      return this.radius - this.strokeWidth / 2
    },

    colorData () {
      return getTextColorData(this.item.color)
    },

    startCoord () {
      return this.getCoord(this.startValue + this.quartersGap, this.arcRadius)
    },

    endCoord () {
      return this.getCoord(this.startValue + this.item.percentage - this.quartersGap, this.arcRadius)
    },

    largeArcFlag () {
      return this.item.percentage > 50
    },

    activatorPercentage () {
      return this.startValue + this.item.percentage / 2
    },

    activatorCoord () {
      return this.getCoord(this.activatorPercentage, this.radius)
    }
  },

  methods: {
    getCoord (value, radius) {
      const anglePercentage = (360 * value) / 100
      const trigoAngle = -(anglePercentage * Math.PI / 180) + Math.PI / 2

      return {
        x: Math.cos(trigoAngle) * radius,
        y: -Math.sin(trigoAngle) * radius
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.repartition-doughnut-quarter-arc {
  fill: transparent;
  stroke: currentColor;

  &.repartition-doughnut-quarter-arc__disabled {
    stroke-opacity: 0.25;
  }
}
</style>
